import SubscribeForm from 'features/simulation/components/subscribe-form/SubscribeForm'
import { useStoreSelector } from 'hooks/store'
import { SubscribeDrawerProps } from 'features/simulation/components/subscribe-drawer/types'
import { useState } from 'react'
import { Drawer, Heading } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import parse from 'html-react-parser'
import { FlowAlternatives } from 'store/customer/enums'

const SubscribeDrawer = ({ isOpen, onRequestClose, product }: SubscribeDrawerProps) => {
  // Redux
  const { flowAlternative } = useStoreSelector((store) => store.customer)

  // i18n
  const { t } = useTranslation('simulation')

  // Local state
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false)

  // Constants
  const isLeadGenCampaign = flowAlternative[FlowAlternatives.TELESALES_CAMPAIGN]

  /**
   * Tracks the request close event if the opportunityId is not set
   */
  const trackedRequestClose = () => {
    onRequestClose()
  }

  const handleConfirmLeadGen = () => {
    setShowConfirmation(true)
  }

  return (
    <Drawer onRequestClose={trackedRequestClose} {...{ isOpen }}>
      {isLeadGenCampaign && showConfirmation ? (
        <>
          <Heading as="h1" variant="h3">
            {t('simulation:leadGenCampaign.confirmation.title')}
          </Heading>
          <p>{parse(t('simulation:leadGenCampaign.confirmation.description'))}</p>
        </>
      ) : (
        <SubscribeForm product={product} finishSubmission={isLeadGenCampaign ? handleConfirmLeadGen : onRequestClose} />
      )}
    </Drawer>
  )
}

export default SubscribeDrawer
